/* eslint-disable max-len */
import { merge } from 'lodash';

import * as ACTION_TYPES from './types';

const initState = {
  status: {
    loadDetails: -1,
    loadList: -1,
    initList: -1,
    doctorPendingRequests: -1,
  },
  details: '',
  doctorPendingRequests: [],
  hasLoadMore: false,
  meta: {
    pagination: {
      page: 0,
      pageSize: 10,
    },
  },
  error: {},
  clinicConversations: {},
};

export default function reducer(state = initState, action) {
  const { type, payload, meta } = action;

  switch (type) {
    case ACTION_TYPES.CONVERSATION_RETRIEVE_REQUESTED:
      return merge({}, state, {
        status: {
          loadDetails: 0,
        },
      });
    case ACTION_TYPES.CONVERSATION_RETRIEVE_SUCCEED:
      return merge({}, state, {
        status: {
          loadDetails: 1,
        },
        details: payload.result.data,
      });
    case ACTION_TYPES.CONVERSATION_RETRIEVE_FAILED:
      return merge({}, state, {
        status: {
          loadDetails: 2,
        },
      });

    case ACTION_TYPES.CONVERSATIONS_RETRIEVE_REQUESTED: {
      const { clinicId } = meta;
      return {
        ...state,
        clinicConversations: {
          ...state.clinicConversations,
          [clinicId]: {
            ...state.clinicConversations[clinicId],
            status: {
              loadList: 0,
            },
          },
        },
      };
    }

    case ACTION_TYPES.CONVERSATIONS_RETRIEVE_SUCCEED: {
      const { data, meta: metaResult } = payload.result;
      const hasLoadMore = data.length === metaResult.pagination.pageSize;
      const { clinicId } = meta;

      return {
        ...state,
        clinicConversations: {
          ...state.clinicConversations,
          [clinicId]: {
            ...state.clinicConversations[clinicId],
            status: {
              loadList: 1,
            },
            ids: meta?.isReplace
              ? [...new Set([...data])]
              : [...new Set([...(state.clinicConversations[clinicId].ids || []), ...data])],
            hasLoadMore,
            meta: metaResult,
          },
        },
      };
    }
    case ACTION_TYPES.CONVERSATIONS_RETRIEVE_FAILED: {
      const { clinicId } = meta;
      return {
        ...state,
        clinicConversations: {
          ...state.clinicConversations,
          [clinicId]: {
            ...state.clinicConversations[clinicId],
            status: {
              loadList: 2,
            },
          },
        },
      };
    }

    case ACTION_TYPES.CONVERSATIONS_CLEAR:
      return {
        ...state,
        ids: [],
      };

    case ACTION_TYPES.CONVERSATION_REMOVE_BY_ID: {
      const currentList = state.clinicConversations[payload.clinicId]?.ids || [];
      const newList = currentList.filter(id => id !== payload.conversationId);

      return {
        ...state,
        clinicConversations: {
          ...state.clinicConversations,
          [payload.clinicId]: {
            ...state.clinicConversations[payload.clinicId],
            ids: newList,
          },
        },
      };
    }

    case ACTION_TYPES.CONVERSATION_ADD_BY_ID: {
      const currentList = state.clinicConversations[payload.clinicId]?.ids || [];
      const newList = [...new Set([...currentList, payload.conversationId])];

      return {
        ...state,
        clinicConversations: {
          ...state.clinicConversations,
          [payload.clinicId]: {
            ...state.clinicConversations[payload.clinicId],
            ids: newList,
          },
        },
      };
    }

    case ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_REQUESTED:
      return merge({}, state, {
        status: {
          doctorPendingRequests: 0,
        },
      });
    case ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_SUCCEED:
      return merge({}, state, {
        status: {
          doctorPendingRequests: 1,
        },
        doctorPendingRequests: payload?.data || [],
      });
    case ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_FAILED:
      return merge({}, state, {
        status: {
          doctorPendingRequests: 2,
        },
      });

    default:
      return state;
  }
}
